Vue.component('chat-node-form', {
    props: ["options", "labellang"],
    template:
        '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="zoomUp"  v-bind:css="options.internal.isAnimationCompatibility">' +
        '<div id="chat-node-form">' +
        '<div class="row no-gutters">' +
        '<div class="nodo-form-title"><b>{{title}}</b></div>' +
        '</div>' +
        '<form class="nodo-form-form perfect-scrollbar">' +
        '<ul class="list-unstyled offset-top-10">' +
        '<li v-for="(item, index) in getFormField" class="li-item">' +
        '<label>{{ item.label }} <span style="color: red; #8e8b8b;" v-if="item.required">*</span></label>' +
        '<template v-if="item.formFieldType === \'Input Box\'">' +
        '<input @blur="validateField(item, index)" class="form-control" @change="forceRerenderForm++" @keypress="forceRerenderForm++" type="text" v-model="item.model" :required="item.required" :placeholder="item.hint" :class="styleInput">' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredField }}</small>' +
        '</template>' +
        '<template  v-if="item.formFieldType === \'Number\'">' +
        '<input @blur="validateField(item, index)" class="form-control" @change="forceRerenderForm++" @keypress="forceRerenderForm++" type="number" v-model="item.model" :placeholder="item.hint" :required="item.required" :class="styleInput">' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredField }}</small>' +
        '</template>' +
        '<template  v-if="item.formFieldType === \'Date\'">' +
        '<input class="form-control" :ref="\'date_\' + index" @change="forceRerenderForm++" type="text" v-model="item.model" readonly @click.prevent="openWidgetPanel(\'date\', index, item)" @focus.prevent="openWidgetPanel(\'date\', index, item)" :placeholder="item.hint" :required="item.required" :class="styleInput" style="background-color: #fff">' +
        '</template>' +
        '<template  v-if="item.formFieldType === \'Email\'">' +
        '<input @blur="validateField(item, index)" class="form-control" @change="forceRerenderForm++" type="email" @keypress="forceRerenderForm++" v-model="item.model" :placeholder="item.hint" :required="item.required" :class="styleInput">' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredEmail }}</small>' +
        '</template>' +
        '<template  v-if="item.formFieldType === \'Phone\'">' +
        '<input @blur="validateField(item, index)" class="form-control" @change="forceRerenderForm++" type="text" @keypress="forceRerenderForm++" v-model="item.model" :placeholder="item.hint" :required="item.required" :class="styleInput">' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredPhone }}</small>' +
        '</template>' +
        '<template v-if="item.formFieldType === \'Datetime\'">' +
        '<input class="form-control" @change="forceRerenderForm++" type="text" v-model="item.model" readonly @click.prevent="openWidgetPanel(\'datetime\', index, item)" @focus.prevent="openWidgetPanel(\'datetime\', index, item)" :placeholder="item.hint" :required="item.required" :class="styleInput" style="background-color: #fff">' +
        '</template>' +
        '<template  v-if="item.formFieldType === \'Time\'">' +
        '<input class="form-control" @change="forceRerenderForm++" type="text" v-model="item.model" readonly @click.prevent="openWidgetPanel(\'time\', index, item)" @focus.prevent="openWidgetPanel(\'time\', index, item)" :placeholder="item.hint" :required="item.required" :class="styleInput" style="background-color: #fff">' +
        '</template>' +
        '<template  v-if="item.formFieldType === \'Password\'">' +
        '<input @blur="validateField(item, index)" class="form-control" @change="forceRerenderForm++" type="password" @keypress="forceRerenderForm++" v-model="item.model" :placeholder="item.hint" :required="item.required" :class="styleInput">' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredField }}</small>' +
        '</template>' +
        '<template v-if="item.formFieldType === \'Checkbox\'">' +
        '<div class="hint">{{item.hint}}</div>' +
        '<div class="form-check" v-for="(box) in item.checkbox">' +
        '<label class="label-container">' +
        '<input class="form-control form-check-input" type="checkbox" @change="checkboxSelected($event, index, item)" v-model="item.model" class="form-node-checkbox" :name="item.label" :value="box">{{box}}' +
        '</label>' +
        '</div>' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredSelection }}</small>' +
        '</template>' +
        '<template v-if="item.formFieldType === \'Select Box\'">' +
        '<div class="hint">{{item.hint}}</div>' +
        '<select class="form-control" @blur="validateField(item, index)" @change="validateField(item, index)" v-model="item.model">' +
        '<option v-for="(option, index) in item.selectBox" :value="option">{{ option }}</option>' +
        '</select>' +
        '<small v-if="errorsList[index]" class="form-text text-muted error-msg">{{ text.formRequiredField }}</small>' +
        '</template>' +
        '<template v-if="item.formFieldType === \'Radio Buttons\'">' +
        '<div class="hint">{{item.hint}}</div>' +
        '<div class="form-check" v-for="(button, index) in item.radioButtons">' +
        '<label class="label-container">' +
        '<input class="form-control form-check-input" type="radio" @change="forceRerenderForm++" v-model="item.model" :name="item.label" class="form-node-radio" :value="button">{{button}}' +
        '</label>' +
        '</div>' +
        '</template>' +
        '</li>' +
        '</ul>' +
        '</form>' +
        '<div class="nodo-form-action-form action-form">' +
        '<button :title="text.skipFormTooltip" class="btn btn-primary btn-skip" v-if="!isFormRequired" @click.prevent="skipForm">{{text.skipForm}}</button>' +
        '<button :title="text.submitFormTooltip" :disabled="formValidation" class="btn btn-primary btn-submit" @click="sendFormValue" @keyup.enter="sendFormValue">{{text.submitForm}}</button>' +
        '</div>' +
        '</div>' +
        '</transition>',

    data: function () {
        return {
            isActive: false,
            title: "",
            isFormRequired: false,
            formField: [],
            styleInput: {
                active: true,
                'text-danger': false
            },
            perfect: null,
            isPanelWidgetOpen: false,
            currentWidgetOpen: null,
            keyboard_date: { type: "date", attributes: {}, fromForm: true },
            keyboard_datetime: { type: "datetime", attributes: {}, fromForm: true },
            keyboard_time: { type: "time", attributes: {}, fromForm: true },
            forceRerender: 0,
            forceRerenderForm: 0,
            errorsList: {},
            text: {
              skipForm: this.labellang.skipForm,
              submitForm: this.labellang.submitForm,
              skipFormTooltip: this.labellang.skipFormTooltip,
              submitFormTooltip: this.labellang.submitFormTooltip,
              formRequiredField: this.labellang.formRequiredField,
              formRequiredSelection: this.labellang.formRequiredSelection,
              formRequiredPhone: this.labellang.formRequiredPhone,
              formRequiredEmail: this.labellang.formRequiredEmail
            }
        }
    },
    created: function () {
        var that = this;
        this.$parent.$on('chatNodeFormEnable', function (data) {
            that.isActive = true;
            that.title = data.title.value;
            that.isFormRequired = data.formRequired.value;
            that.formField = data.formField
            for (var index in that.formField) {
                if (that.formField[index].formFieldType == "Checkbox") {
                    that.formField[index].model = [];
                    if (that.formField[index].defaultValue) {
                      try {
                        that.formField[index].model = JSON.parse(that.formField[index].defaultValue);
                      } catch (err) {}
                    }
                } else {
                    that.formField[index].model = "";
                    if (that.formField[index].defaultValue && that.formField[index].defaultValue !== "null"  && that.formField[index].defaultValue !== "undefined") {
                      that.formField[index].model = that.formField[index].defaultValue;
                    }
                }
            }
            if (data.keyboard_date) {
                that.keyboard_date.attributes = data.keyboard_date.attributes
            }
            if (data.keyboard_datetime) {
                that.keyboard_datetime.attributes = data.keyboard_datetime.attributes
            }
            if (data.keyboard_time) {
                that.keyboard_time.attributes = data.keyboard_time.attributes
            }
            that.contentShow();
        });
    },
    mounted: function () {
        var that = this;
        bus.$on('onShowPanelClosing', function (val) {
            //non chiudo, perchè l'utente può ancora decidere di non terminare
            //that.hideFormSection(val);
        });
        bus.$on('confirmCloseSession', function(val) {
          that.hideFormSection(val);
        })
        bus.$on('onCloseWidgetForm', function (val) {
            that.closeWidget(val);
        });
        bus.$on('newUserEventLS', function(e) {
            that.closeWidget(false);
        });
        bus.$on('onCloseDateWidgetInForm', function(val) {
            that.onCloseDateWidgetInForm(val);
        });
    },
    methods: {
      validateField: function(val, index) {
        if(val.required) {
          switch (val.formFieldType) {
            case "Input Box":
            case "Number":
            case "Password":
              if (val.model && val.model.length > 0) {
                delete this.errorsList[index];
              } else {
                this.errorsList[index] = true;
                this.forceRerender++;
              }
              break;
            case "Email":
              var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if(re.test(val.model)){
                delete this.errorsList[index];
              }else{
                this.errorsList[index] = true;
                this.forceRerender++;
              }
              break;
            case "Phone":
              var phoneRe = /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
              if(phoneRe.test(val.model.trim())){
                delete this.errorsList[index];
              }else{
                this.errorsList[index] = true;
                this.forceRerender++;
              }
              break;
            case "Checkbox":
              if(val.model && val.model.length > 0){
                delete this.errorsList[index];
              }else{
                this.errorsList[index] = true;
                this.forceRerender++;
              }
              break;
            case "Select Box":
              this.forceRerenderForm++
              if(val.model && val.model.length > 0) {
                delete this.errorsList[index];
              }else{
                this.errorsList[index] = true;
                this.forceRerender++;
              }
              break;
            default:
              delete this.errorsList[index];
              break;
          }
        }else{
          delete this.errorsList[index];
          //se la mail non è required allora può anche essere vuota, ma se c'è deve comunque essere valida
          //se sono required, caso sopra
          if(val.formFieldType == 'Email'){
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(re.test(val.model) || val.model === ""){
              delete this.errorsList[index];
            }else{
              this.errorsList[index] = true;
              this.forceRerender++;
            }
          }
          //se il phone non è required allora può anche essere vuoto, ma se c'è deve comunque essere valido
          //se sono required, caso sopra
          if(val.formFieldType == 'Phone'){
            var phoneRe = /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
            if(phoneRe.test(val.model.trim()) || val.model === ""){
              delete this.errorsList[index];
            }else{
              this.errorsList[index] = true;
              this.forceRerender++;
            }
          }
        }
        this.forceRerenderForm++;
      },
        hideFormSection: function (val) {
            this.isActive = !val
        },
        contentShow: function (val) {
            var that = this;
            setTimeout(function () {
                try {
                    that.perfect = new PerfectScrollbar(".perfect-scrollbar", {
                        maxScrollbarLength: 100
                    });
                } catch (e) { }
            }, 100);
        },
        openWidgetPanel: function (type, index, item) {
            var that = this;
            this.isPanelWidgetOpen = true;
            this.currentWidgetOpen = index;
            bus.$emit("onInputClean");
            bus.$emit("onInputMsgDisabled", true);

            switch (type) {
                case "date":
                    bus.$emit("onShowPanelCalendar", item.model||true); // mostra tastiera data
                    setTimeout(function() { bus.$emit("onCallTypeCalendar", that.keyboard_date) }, 200);
                    break;
                case "time":
                    bus.$emit("onShowPanelCalendar", item.model||true);
                    setTimeout(function() { bus.$emit("onCallTypeCalendar", that.keyboard_time) }, 200);
                    break;
                case "datetime":
                    bus.$emit("onShowPanelCalendar", item.model||true);
                    setTimeout(function() { bus.$emit("onCallTypeCalendar", that.keyboard_datetime) }, 200);
                    break;
            }
        },
        onCloseDateWidgetInForm: function(msg) {
            var that = this;
            that.isPanelWidgetOpen = false;
            if (that.formField && that.currentWidgetOpen !== null && that.currentWidgetOpen !== undefined && that.formField[that.currentWidgetOpen]){
                that.formField[that.currentWidgetOpen].model = msg;
                that.forceRerenderForm++;
            }
            that.forceRerender ++;
            that.currentWidgetOpen = null;
        },
        closeWidget: function (msg) {
            this.onCloseDateWidgetInForm(msg);
            this.isActive = false;
        },
        checkboxSelected: function (evt, index, item) {
            var that = this;
            //tutta la parte di modifica del model non è necessaria perchè ci pensa già vue a fare il binding
            this.forceRerenderForm++;
            this.validateField(item, index);
        },
        removeWidgetPanel: function () {
            bus.$emit("onShowPanelCalendar", false);
            bus.$emit("onShowPanelGeoLocation", false);
            bus.$emit("onShowPanelKeyReplace", false);
            bus.$emit("onShowPanelSurvey", false);
            bus.$emit("onInputMsgDisabled", false);
            this.isPanelWidgetOpen = false;

        },
        sendFormValue: function () {
          var that = this;
          this.isActive = false;
          var formValues = {};
          for (var i = 0; i < that.formField.length; i++) {
            var field = that.formField[i];
            formValues[this.replaceAll("%", "", field.variable)] = field.model;
          }
          var event = {
            eventName: this.options.ConvyEvent.SYSTEM_CONVY_FORM_SUBMIT,
            parameters: formValues,
          };
          this.options.internal.bridge.sendChatEvent(event);
        },
        skipForm: function() {
            var that = this;
            this.isActive = false;
            var event = {
              eventName: this.options.ConvyEvent.SYSTEM_CONVY_FORM_SKIP
            };
			      this.options.internal.bridge.sendChatEvent(event);
        },
        replaceAll: function (search, replacement, string) {
            return string.replace(new RegExp(search, 'g'), replacement);
        }
    },
    computed: {
        formValidation: function () {
            this.forceRerenderForm;
            var that = this;
            for(var i=0; i<that.formField.length; i++){
                var field = that.formField[i];
                if (field.required) {
                    if (field.model == "" || (Array.isArray(field.model) && field.model == [])) {
                        return true;
                    }
                  //i campi email e phone devono essere per forza compliant con la regex
                  if(field.formFieldType == "Email"){
                    if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field.model)) {
                      return true;
                    }
                  }
                  if(field.formFieldType == "Phone"){
                    if(!/^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(field.model)){
                      return  true;
                    }
                  }
                }else{
                  //se i campi email e phone non sono required allora possono anche essere vuoti
                  if(field.formFieldType == "Email"){
                    if (field.model !== "" && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field.model)) {
                      return true;
                    }
                  }
                  if(field.formFieldType == "Phone"){
                    if(field.model !== "" && !/^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(field.model)){
                      return  true;
                    }
                  }
                }
            }
            return false;
        },
        getFormField: function() {
            this.forceRerender;
            return this.formField.map(function (field) {
              if (!field.defaultValue || field.defaultValue === "null" || field.defaultValue === "undefined") {
                field.defaultValue = "";
              }
              return field;
            });
        }
    }
})
